import { SupplierList as SupplierListR4 } from './fhir/r4/supplierList.js';
import { RoutingRule as RoutingRuleR4 } from './fhir/r4/routingRule.js';
import {
  DataProvider as DataProviderR4,
  DataProviderClient as DataProviderClientR4,
  DataProviderEndpoint as DataProviderEndpointR4,
  DataProviderSupportedResource as DataProviderSupportedResourceR4,
} from './fhir/r4/dataProvider.js';
import {
  DataConsumer as DataConsumerR4,
  DataConsumerEndpoint as DataConsumerEndpointR4,
} from './fhir/r4/dataConsumer.js';
import {
  ScheduleDefinition as ScheduleDefinitionR4,
  ScheduleDefinitionOccurrence as ScheduleDefinitionOccurrenceR4,
  ScheduleDefinitionOccurrenceDays as ScheduleDefinitionOccurrenceDaysR4,
  ScheduleDefinitionOccurrenceDaysDuration as ScheduleDefinitionOccurrenceDaysDurationR4,
  ScheduleDefinitionOccurrenceDaysTime as ScheduleDefinitionOccurrenceDaysTimeR4,
} from './fhir/r4/scheduleDefinition.js';
import {
  DataProvider as DataProviderSTU3,
  DataProviderClient as DataProviderClientSTU3,
  DataProviderEndpoint as DataProviderEndpointSTU3,
  DataProviderSupportedResource as DataProviderSupportedResourceSTU3,
} from './fhir/stu3/dataProvider.js';
import {
  DataConsumer as DataConsumerSTU3,
  DataConsumerEndpoint as DataConsumerEndpointSTU3,
} from './fhir/stu3/dataConsumer.js';
import {
  ScheduleDefinition as ScheduleDefinitionSTU3,
  ScheduleDefinitionOccurrence as ScheduleDefinitionOccurrenceSTU3,
  ScheduleDefinitionOccurrenceDays as ScheduleDefinitionOccurrenceDaysSTU3,
  ScheduleDefinitionOccurrenceDaysDuration as ScheduleDefinitionOccurrenceDaysDurationSTU3,
  ScheduleDefinitionOccurrenceDaysTime as ScheduleDefinitionOccurrenceDaysTimeSTU3,
} from './fhir/stu3/scheduleDefinition.js';

import * as OAuth2 from './oauth/index.js';

export namespace FhirR4 {
  /**
   * SupplierList defines a list of Organizations
   * that can provide a specified service/item/procedure signified by the provision
   */
  export interface SupplierList extends SupplierListR4 {}
  /**
   * RoutingRule defines a routing between two Organizations where one is a sender,
   * and the other a receiver for a given process, as well as the time period for which it is valid.
   * The definition optionally includes the sender's local code(s) for the process, as well as a
   * reference to a ConceptMap that instructs the consumer how to convert the sender's local codes
   * to ones the receiver prefers.
   */
  export interface RoutingRule extends RoutingRuleR4 {}
  /**
   * DataProvider Define a source of data for the regional shared care record
   */
  export interface DataProvider extends DataProviderR4 {}
  /**
   * Subtypes within a DataProvider
   */
  export interface DataProviderClient extends DataProviderClientR4 {}
  export interface DataProviderEndpoint extends DataProviderEndpointR4 {}
  export interface DataProviderSupportedResource extends DataProviderSupportedResourceR4 {}
  /**
   * DataConsumer defines a consumer of data for the regional shared care record
   */
  export interface DataConsumer extends DataConsumerR4 {}
  /**
   * Subtypes within a DataConsumer
   */
  export interface DataConsumerEndpoint extends DataConsumerEndpointR4 {}

  /**
   * ScheduleDefinition defines a source of data for the regional shared care record
   */
  export interface ScheduleDefinition extends ScheduleDefinitionR4 {}
  /**
   * Subtypes within ScheduleDefinition
   */
  export interface ScheduleDefinitionOccurrence extends ScheduleDefinitionOccurrenceR4 {}
  export interface ScheduleDefinitionOccurrenceDays extends ScheduleDefinitionOccurrenceDaysR4 {}
  export interface ScheduleDefinitionOccurrenceDaysDuration extends
    ScheduleDefinitionOccurrenceDaysDurationR4 {}
  export interface ScheduleDefinitionOccurrenceDaysTime
    extends ScheduleDefinitionOccurrenceDaysTimeR4 {}
}
export namespace FhirSTU3 {
  /**
   * DataProvider Define a source of data for the regional shared care record
   */
  export interface DataProvider extends DataProviderSTU3 {}
  /**
   * Subtypes within a DataProvider
   */
  export interface DataProviderClient extends DataProviderClientSTU3 {}
  export interface DataProviderEndpoint extends DataProviderEndpointSTU3 {}
  export interface DataProviderSupportedResource extends DataProviderSupportedResourceSTU3 {}
  /**
   * DataConsumer defines a consumer of data for the regional shared care record
   */
  export interface DataConsumer extends DataConsumerSTU3 {}
  /**
   * Subtypes within a DataConsumer
   */
  export interface DataConsumerEndpoint extends DataConsumerEndpointSTU3 {}

  /**
   * ScheduleDefinition defines a source of data for the regional shared care record
   */
  export interface ScheduleDefinition extends ScheduleDefinitionSTU3 {}
  /**
   * Subtypes within ScheduleDefinition
   */
  export interface ScheduleDefinitionOccurrence extends ScheduleDefinitionOccurrenceSTU3 {}
  export interface ScheduleDefinitionOccurrenceDays extends ScheduleDefinitionOccurrenceDaysSTU3 {}
  export interface ScheduleDefinitionOccurrenceDaysDuration extends
    ScheduleDefinitionOccurrenceDaysDurationSTU3 {}
  export interface ScheduleDefinitionOccurrenceDaysTime
    extends ScheduleDefinitionOccurrenceDaysTimeSTU3 {}
}

export { OAuth2 };
